import React from 'react';

const RESUME_TASK_HELP = {
  'Create resume draft': {
    title: 'How to write your first resume!',
    content: [
      'Read the Resume lesson on the Lesson Tree tab',
      "Find your school's resume tips and template",
      "You can find many templates online (search Jake's resume template)",
      'Keep it to 1 page only',
      'Start each bullet point with an action verb',
    ],
  },
  'Have one person review your resume': {
    title: 'Get feedback on your resume',
    content: [
      "Make a free appointment with your school's career center",
      'Or, ask a friend or family member who is in the industry you want to work in',
      'You can also swap resumes with a friend!',
    ],
  },
  'Finalize resume': {
    title: 'Last steps!',
    content: [
      'Incorporate all feedback from all reviewers',
      'Do a final proofread for any remaining errors',
      'Bonus: update your LinkedIn profile to match your finalized resume',
    ],
  },
};

const ResumeTaskHelpModal = ({ isOpen, onClose, taskName }) => {
  if (!isOpen) return null;

  const helpContent = RESUME_TASK_HELP[taskName] || {
    title: 'Resume Task Help',
    content: ['No specific help content available for this task.'],
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="fixed inset-0 bg-black opacity-30" onClick={onClose}></div>

        <div className="relative bg-white rounded-lg max-w-md p-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-semibold text-gray-900">{helpContent.title}</h3>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
              <span className="sr-only">Close</span>
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div className="mt-4">
            <ul className="space-y-3">
              {helpContent.content.map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="shrink-0 h-5 w-5 text-black-500">•</span>
                  <span className="ml-2 text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-6 flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-hidden focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Got it
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResumeTaskHelpModal;
